import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useWeb3React } from "@web3-react/core";
import "../../../../splash_event.css";
import {axiosInstance, encryptLoginData, getIndexerUserTokens} from "../../../../../../../utils";
import axios from "axios";
import $ from "jquery";

let current_user_id = 0;
let racer_details_global = [];

export const TeddyLandingPage = (props) => {
    const dispatch = useDispatch();
    const { page_loaded }= useSelector((state) => state.app);
    const { racerID, userID, accountAddress } = useSelector((state) => state.account);

    const { chainId, account } = useWeb3React();

    const [pageSet, setPage] = useState(false);
    const [lineupHTML,setLineupHTML] = useState([]);

    /* EXR Event ID */
    var exreventid = 2;
    let signup_user_id = 0;

    document.addEventListener('DOMContentLoaded', function() {

    });

    function showRegisterBox() {
        $('html,body').scrollTop(0);
        props.openRegistrationForm();
    }

    window.addEventListener('resize', function() {
        window.resetCenterHeight();
    });

    if(pageSet === false) {
        setPage(true);
    }

    window.addEventListener("hashchange",
    function(){ 
        window.location.reload(); 
    }, false);

    return(<>
        <div className="row" style={{marginTop:'50px'}}>
            <div className="col s12 m10 offset-m1 white-text">
                <div className="event-register-subheadline">
                    <span><img src="https://media.exiledracers.com/events/teddydao/teddy_dao_planet.png?1234" style={{width:'35px'}} /></span>
                    <span style={{marginLeft:'10px',verticalAlign:'top'}}>PREDICT ON EXR VIP TEDDY RACERS</span>
                </div>
            </div>
            <div className="col s12 m10 offset-m1 white-text" style={{marginTop:'20px'}}>
                <div className="event-register-subheadline">
                <span><img src="https://media.exiledracers.com/events/teddydao/teddy_dao_heart.png" style={{width:'35px'}} /></span>
                    <span style={{marginLeft:'10px',verticalAlign:'top'}}>ENTER FREE WITH OPTIONAL DONATIONS</span>
                </div>
            </div>
            <div className="col s12 m10 offset-m1 white-text" style={{marginTop:'20px'}}>
                <div className="event-register-subheadline">
                <span><img src="https://media.exiledracers.com/events/teddydao/teddy_dao_coin.png" style={{width:'35px'}} /></span>
                    <span style={{marginLeft:'10px',verticalAlign:'top'}}>WIN PRIZES AND MATCHED DONATIONS*</span>
                </div>
            </div>
        </div>
        <div className="row" style={{marginTop:'30px'}}>
            <div className="col s12 m10 offset-m1 show-on-large hide-on-med-and-down">
                <div className="row white-text" style={{cursor:'pointer',marginLeft:'5px',marginRight:'5px',marginBottom:'0px'}} 
                    title="Register For Exiled Racers" onClick={()=>showRegisterBox()}>
                    <img src="https://media.exiledracers.com/events/teddydao/teddy_dao_start_button.png" style={{height:'100px'}} />
                </div>
                <div className="row grey-text" style={{marginLeft:'25px',fontSize:'28px'}}>
                    20&nbsp;&nbsp;DEC&nbsp;&nbsp;2023
                </div>
            </div>
            <div className="col s10 offset-s1 m6 offset-m3 show-on-med-and-down hide-on-large-only center-align">
                <div className="row" style={{cursor:'pointer',marginBottom:'0px'}} onClick={()=>showRegisterBox()}>
                    <img src="https://media.exiledracers.com/events/teddydao/teddy_dao_start_button.png" style={{height:'90px'}} />
                </div>
                <div className="row grey-text" style={{fontSize:'28px'}}>
                    20&nbsp;&nbsp;DEC&nbsp;&nbsp;2023
                </div>
            </div>
        </div>
                        
    </>);
};